import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { EffectiveCapabilities } from './capabilities.model';

/**
 * Cliente del conjunto efectivo de capacidades.
 *
 * El proyecto no viaja aquí como parámetro: lo pone el `AuthInterceptor` en `x-project-id`, que es
 * la misma cabecera que el resto de la aplicación ya manda. Pasarlo además por la URL abriría la
 * puerta a que ambos discrepen.
 */
@Injectable({ providedIn: 'root' })
export class CapabilitiesService {
  private readonly url = `${environment.genaiApiUrl}/authz/effective-capabilities`;

  constructor(private readonly http: HttpClient) {}

  fetch(): Observable<EffectiveCapabilities> {
    return this.http.get<EffectiveCapabilities>(this.url);
  }
}
